<template>
  <div>
    <v-row>
      <!-- Exercise column -->
      <v-col cols="12">
        <exercise-logic-id
          exCollection="logicSystemExCollection"
          refCollection=""
          @ready="onReady"
          @error="onError"
          @saved="onSaved"
          @savedNext="onSavedNext"
          @loadedEx="onLoadedEx"
          @modifyEx="onModifyEx"
          @loadedRef="onLoadedRef"
          :doc="doc"
          :shared="false"
          :projectShared="false"
          :pid="true"
          :eid="$route.params.eid"
          :synced="false"
        >
          <template slot-scope="{ saveExercise, doc }">
            <v-row>
              <v-col cols="4" class="mb-4">
                <h2 class="headline">Logic System</h2>
              </v-col>
            </v-row>

            <v-row v-if="doc">
              <v-col cols="12">
                <v-card>
                  <v-card-title>
                    Document settings
                  </v-card-title>
                  <v-card-text>
                    <v-text-field
                      label="Title"
                      v-model.trim="doc.title"
                      type="text"
                      required
                      :hide-details="false"
                      color="amber"
                    ></v-text-field>

                    <v-select
                      label="Column width"
                      v-model.trim="doc.cols"
                      :items="['1', '2', '3', '4', '6', '12', 'auto']"
                    />

                    <v-select
                      label="Theme"
                      v-model.trim="doc.theme"
                      :items="['dark', 'light']"
                    />

                    <v-select
                      label="Type"
                      v-model.trim="doc.type"
                      :items="['large', 'medium', 'small', 'waterfall']"
                    />

                    <div class="d-flex flex-wrap">
                      <v-switch
                        v-model="doc.controls"
                        label="Controls"
                        color="amber"
                        class="mr-3 ml-3"
                        inset
                      ></v-switch>

                      <v-switch
                        v-model="doc.note"
                        label="Description"
                        color="amber"
                        class="mr-3 ml-3"
                        inset
                      ></v-switch>

                      <v-switch
                        v-model="doc.tags"
                        label="Tags"
                        color="amber"
                        class="mr-3 ml-3"
                        inset
                      ></v-switch>

                      <v-switch
                        v-model="doc.compact"
                        label="Compact"
                        color="amber"
                        class="mr-3 ml-3"
                        inset
                      ></v-switch>

                      <v-switch
                        v-model="doc.nesting"
                        label="Show nesting"
                        color="amber"
                        class="mr-3 ml-3"
                        inset
                      ></v-switch>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-stepper v-model="e1">
              <v-stepper-header>
                <v-stepper-step
                  color="amber"
                  :complete="e1 > 1"
                  step="1"
                  @click="el = 1"
                  >Parameters</v-stepper-step
                >
                <v-divider></v-divider>
                <v-stepper-step
                  color="amber"
                  :complete="e1 > 2"
                  step="2"
                  @click="el = 2"
                  >Questions</v-stepper-step
                >
                <v-divider></v-divider>
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-row>
                    <v-col cols="12">
                      <v-card>
                        <v-card-title>
                          Add a new group
                        </v-card-title>
                        <v-card-text>
                          <div class="d-flex align-end justify-space-between">
                            <v-text-field
                              v-model="listName"
                              label="Page title"
                              :hide-details="true"
                              class="ma-0"
                              color="amber"
                              placeholder="Group name"
                            ></v-text-field>

                            <v-btn
                              @click="addList('listOne')"
                              color="amber"
                              class="ma-0 ml-5"
                              light
                              >Add Section</v-btn
                            >
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>

                  <v-sheet :color="computedTheme" class="mt-4">
                    <div class="pa-4">
                      <div class="">
                        <draggable
                          :class="doc.cols === 'auto' ? 'auto' : 'row'"
                          group="outer"
                          :list="doc.listOne"
                          id="iso"
                        >
                          <structure-col
                            v-for="(item, index) in doc.listOne"
                            :key="`list-${index}`"
                            v-model="item.children"
                            :item="item"
                            :attrs="{
                              cols: doc.cols,
                              controls: doc.controls,
                              theme: doc.theme,
                              type: doc.type,
                              note: doc.note,
                              tags: doc.tags,
                              compact: doc.compact,
                              add: true,
                              local: doc.local,
                              listTwo: dropdownList,
                              nesting: doc.nesting,
                            }"
                            class="iso-item"
                            @onChangeName="onChangeName($event, 'listOne')"
                            @onEditList="onEditList($event, 'listOne')"
                            @onDeleteList="onDeleteList($event, 'listOne')"
                            @deleteChildren="deleteChildren"
                          ></structure-col>
                        </draggable>
                      </div>
                    </div>
                  </v-sheet>

                  <bottom-navigation
                    v-if="doc"
                    :save="true"
                    :next="true"
                    :prev="false"
                    :gridView="false"
                    :gridToggle="false"
                    :list="`logic-system`"
                    @save="saveExercise(true)"
                    @prev="prevStep"
                    @next="nextStep"
                  >
                  </bottom-navigation>
                </v-stepper-content>
                <!-- Step 2  -->
                <v-stepper-content step="2">
                  <v-row>
                    <v-col cols="12">
                      <v-card>
                        <v-card-title>
                          Add a new group
                        </v-card-title>
                        <v-card-text>
                          <div class="d-flex align-end justify-space-between">
                            <v-text-field
                              v-model="listName"
                              label="Page title"
                              :hide-details="true"
                              class="ma-0"
                              color="amber"
                              placeholder="Group name"
                            ></v-text-field>

                            <v-btn
                              @click="addList('listTwo')"
                              color="amber"
                              class="ma-0 ml-5"
                              light
                              >Add Section</v-btn
                            >
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="9">
                      <v-sheet :color="computedTheme" class="mt-4">
                        <div class="pa-4">
                          <div class="">
                            <draggable
                              :class="doc.cols === 'auto' ? 'auto' : 'row'"
                              group="outer"
                              :list="doc.listTwo"
                              id="iso"
                            >
                              <structure-col
                                v-for="(item, index) in doc.listTwo"
                                :key="`list-${index}`"
                                v-model="item.children"
                                :item="item"
                                :attrs="{
                                  cols: 12,
                                  controls: doc.controls,
                                  theme: doc.theme,
                                  type: doc.type,
                                  note: doc.note,
                                  tags: doc.tags,
                                  compact: doc.compact,
                                  add: true,
                                  local: doc.local,
                                  listOne: doc.listOne,
                                  listTwo: dropdownList,
                                  nesting: doc.nesting,
                                }"
                                class="iso-item"
                                @onChangeName="onChangeName($event, 'listTwo')"
                                @onEditList="onEditList($event, 'listTwo')"
                                @onDeleteList="onDeleteList($event, 'listTwo')"
                              ></structure-col>
                            </draggable>
                          </div>
                        </div> </v-sheet
                    ></v-col>
                    <v-col cols="3">
                      <div v-for="item in doc.listOne" :key="item.id">
                        <p class="text-h6 mt-4 mb-2">{{ item.title }}</p>
                        <ul>
                          <li v-for="a in item.children" :key="a.id">
                            {{ a.name }}
                            <ul>
                              <li v-for="b in a.children" :key="b.id">
                                {{ b.name }}
                                <ul>
                                  <li v-for="c in b.children" :key="c.id">
                                    {{ c.name }}
                                    <ul>
                                      <li v-for="d in c.children" :key="d.id">
                                        {{ d.name }}
                                      </li>
                                    </ul>
                                  </li>
                                </ul>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </div>
                      <!-- <pre>{{ doc.listOne }}</pre> -->
                    </v-col>
                  </v-row>

                  <bottom-navigation
                    v-if="doc"
                    :save="true"
                    :next="false"
                    :prev="true"
                    :gridView="false"
                    :gridToggle="false"
                    :list="`logic-system`"
                    @save="saveExercise(true)"
                    @prev="prevStep"
                    @next="nextStep"
                  >
                  </bottom-navigation>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </template>
        </exercise-logic-id>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="800">
      <v-card v-if="dialogMode == 'save'">
        <v-card-title
          class="headline"
          v-text="$t('exercise_service.saved.title')"
        ></v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="closeDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
import { ExerciseLogicId } from "@/components/exercises";

// import { UnitSubItems } from "@/components/units";

import draggable from "vuedraggable";

import { StructureCol } from "@/views/user/exercises/logic-system";

// const fb = require("@/firebaseConfig.js");

export default {
  name: "UserLogicSystemId",
  data() {
    return {
      e1: 1,
      exercises: null,
      refs: null,
      dialog: false,
      iso: null,
      moveEl: null,
      moveList: null,
      dialogMode: "add",
      allItems: null,
      listName: "",
      test: false,
      revision: 1,
      dropdownList: [],
      doc: {
        cols: "4",
        listOne: [],
        listTwo: [],
        allItems: [],
        title: "",
        controls: true,
        theme: "light",
        type: "large",
        note: false,
        edit: true,
        logos: false,
        tags: false,
        compact: false,
        nesting: false,
        categories: [],
        local: {
          audiences: [],
          categories: [],
          assets: [],
        },
      },
      listLength: 1,
      debug: false,
    };
  },
  components: {
    BottomNavigation,
    ExerciseLogicId,
    StructureCol,
    // UnitSubItems,
    draggable,
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
    computedWidth() {
      if (this.doc) {
        let unit = 50 / 10;
        return { width: `${unit * this.doc.cols}%` };
      } else {
        return null;
      }
    },
    computedTheme() {
      return this.doc.theme === "light" ? "grey lighten-4" : "grey darken-3";
    },
  },

  watch: {
    doc: {
      deep: true,
      handler() {
        this.revision++;
      },
    },
  },
  mounted() {
    this.getListTwo();
  },

  methods: {
    nextStep() {
      this.e1++;
    },
    prevStep() {
      this.e1--;
    },
    onReady() {},
    onError() {
      console.log("error");
    },
    onSaved() {
      this.dialog = true;
      this.dialogMode = "save";
    },
    onLoadedRef(refs) {
      if (refs) {
        this.refs = refs[0];
      }
    },
    onLoadedEx(items) {
      // this.initIso();
      if (items) {
        this.mergeArrays(items[0].doc);
        if (items.length) {
          this.doc.controls = items[0].doc.controls;
          this.doc.note = items[0].doc.note;
          this.getListTwo();
        }
      }
    },
    onModifyEx(items) {
      if (items) {
        this.exercises = [...items];
      }
    },
    onSavedNext() {
      this.nextStep();
    },
    addList(model) {
      if (this.listName) {
        let lc = this.listName.replace(/\s/g, "").toLowerCase();
        this.doc[model].push({
          id: new Date().valueOf(),
          title: this.listName,
          name: lc,
          children: [],
        });
        this.listName = "";
      }
    },
    onChangeName(params, model) {
      const item = this.doc[model].find((x) => x.id === params.id);
      const indexOfItem = this.doc[model].indexOf(item);
      let lc = params.title.replace(/\s/g, "").toLowerCase();
      item.title = params.title;
      item.name = lc;
      this.$set(this.doc[model], indexOfItem, item);
    },
    onDeleteList(params, model) {
      // loop through elements in list and re-distribute to master list
      let item = this.doc[model].find((x) => x.id === params.id);
      let index = this.doc[model].indexOf(item);
      this.cloneChildren(item);
      this.doc[model].splice(index, 1);
    },
    cloneChildren(item) {
      const items = [...item.children];
      this.doc.allItems.push({
        title: "Deleted Items",
        name: "deleted",
        children: items,
      });
    },
    onEditList(params, model) {
      let item = this.doc[model].find((x) => x.id === params.id);
      if (item) {
        let index = this.doc[model].indexOf(item);
        item = {
          ...params,
        };
        this.$set(this.doc[model], index, item);
      }
      if (model === "listTwo") {
        this.getListTwo();
      }
    },
    deleteChildren($event) {
      this.doc.listTwo.forEach((b) => {
        this.nestedCheck(b.children, $event.item);
      });
    },
    nestedCheck(arr, id) {
      this.doc.listOne.forEach((a) => {
        const parseId = parseInt(id);
        arr.forEach((b) => {
          const keyArr = b[a.name];
          const lostItems = keyArr.filter((x) => parseInt(x) === parseId);
          lostItems.forEach((c) => {
            const indexOfItem = keyArr.indexOf(c);

            keyArr.splice(indexOfItem, 1);
          });
        });
      });
      if (arr.children && arr.children.length) {
        this.nestedCheck(arr.children, id);
      }
    },
    getListTwo() {
      console.log("getting list two");
      this.dropdownList.length = 0;
      this.doc.listTwo.forEach((element) => {
        if (element.children && element.children.length > 0) {
          this.getChildrenTwo(element.children, element.title);
        }
      });
    },
    getChildrenTwo(arr, title) {
      arr.forEach((element) => {
        this.dropdownList.push({
          name: `${title} – ${element.name}`,
          id: element.id,
        });
        if (element.children && element.children.length) {
          this.getChildrenTwo(element.children, title);
        }
      });
    },
    mergeArrays(arr) {
      console.log("arr", arr);
      if (this.doc) {
        Object.entries(arr).forEach(([outerKey, value]) => {
          if (typeof value === "object") {
            Object.entries(value).forEach(([key, value]) => {
              this.doc[outerKey][key] = value;
            });
          }
          if (typeof value === "string") {
            this.doc[outerKey] = value;
          }
          if (typeof value === "boolean") {
            this.doc[outerKey] = value;
          }
        });
      } else {
        this.doc = arr;
      }
    },
    showNote($event) {
      console.log("show note", $event);
      this.dialogMode = "show";
      this.cardId = $event;
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      this.dialogMode = "";
    },
  },
};
</script>

<style lang="scss">
.auto {
  display: flex;
  flex-wrap: nowrap;
  .col-auto {
    width: auto;
    flex: 1;
  }
}
</style>
